import React from 'react';
import ETVTable from "../tools/ETVTable";
import { Box, Button, LinearProgress, Tooltip } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import IconButton from '@mui/material/IconButton';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import * as ETVConstants from '../ETVConstants';

class ScreenSelection extends React.Component {

	constructor(props) {
      super(props);
      this.state = {
        items:[],
        selected: [],
        isLoaded: false,
		isBulkUpdating:false,
      };
    }

    state = {
      items:[],
      selected: [],
      isLoaded: false,
	  isBulkUpdating:false,
    }

		componentDidUpdate(prevProps,prevState) {
      if(!this.state.isLoaded) {
        this.loadItems();
      }
      if(prevProps.content_id!==this.props.content_id) {
        this.loadItems();
      }
		}

    componentDidMount() {
      this.loadItems();
    }

    loadItems() {
      //console.log("xx---------------------loading screens");
			var url = ETVConstants.getServerBase()+"/playlist?action=selected_devices&user_id="+this.props.user_id+"&channel="+this.props.channel+"&content_id="+this.props.content_id;
      //console.log("loading url="+url);
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            //console.log("items="+result.all_devices.length);
						var allDevices = result.all_devices;
						allDevices.sort( (a,b) => a.device_name.localeCompare(b.device_name));
            this.setState({
              items: allDevices,
              selected: result.selected_devices,
              isLoaded: true,
            });
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            this.setState({
              items:[],
              isLoaded: false,
              error
            });
          }
        )
    }

    addContentToDevice( deviceID) {
      var contentID = this.props.library_element.content_id;
      //console.log("add content to playlist");
      var url = ETVConstants.getServerBase()+"/playlist?action=add_content_to_device&content_id="+contentID+"&device_id="+deviceID+"&channel="+this.props.channel;
      this.updateScreenList(url);
      this.setState({isLoaded:false});
      if(this.props.updatedHook) {
        this.props.updatedHook();
      }
    }

    removeContentFromDevice( deviceID) {
      var contentID = this.props.library_element.content_id;
      //console.log("remove from playlist");
      var url = ETVConstants.getServerBase()+"/playlist?action=remove_content_from_device&content_id="+contentID+"&device_id="+deviceID+"&channel="+this.props.channel;
      this.updateScreenList(url);
      this.setState({isLoaded:false});
      if(this.props.updatedHook) {
        this.props.updatedHook();
      }
    }

	bulkSetScreens = async (selectAll) => {
		const contentID = this.props.library_element.content_id;
		const selected = this.state.selected || [];
		const deviceIDs = selectAll
			? this.state.items.map(item => item.id).filter(id => !selected.includes(id))
			: selected.slice();

		if(deviceIDs.length===0) return;
		this.setState({isBulkUpdating:true});
		try {
			await Promise.all(deviceIDs.map(deviceID => {
				const action = selectAll ? 'add_content_to_device' : 'remove_content_from_device';
				const url = ETVConstants.getServerBase()+`/playlist?action=${action}&content_id=${contentID}&device_id=${deviceID}&channel=${this.props.channel}`;
				return fetch(url).then(res => res.json());
			}));
			this.setState({isBulkUpdating:false,isLoaded:false});
			if(this.props.updatedHook) this.props.updatedHook();
		} catch(error) {
			this.setState({isBulkUpdating:false,error});
		}
	}

    updateScreenList( url) {
			//console.log("xxx---->"+url);
			fetch(url)
				.then( res => res.json() )
				.then(
						(result) => {
							this.setState({isLoaded:false});
						},
						(error) => {
              this.setState({isLoaded:false});
							//console.log("yyy-------> "+error);
						}
					)
		}

    showWindow(divID, show) {
      this.setState({show_overlay:show});
      show?this.setState({window:divID}):this.setState({window:''});
    }

    isSelectedScreen( deviceID) {
      if(!this.state.selected) return false;
      for(var i=0; i<this.state.selected.length; i++) {
        if(this.state.selected[i]===deviceID) {
          return true;
        }
      }
      return false;
    }

    render() {

      const columnsData= [
					{ title: ETVConstants.trans('select'), field: 'selected', width:70, render: rowData => this.isSelectedScreen(rowData.id)?
				<Tooltip title={ETVConstants.trans('remove')}><IconButton color='primary' onClick={()=>this.removeContentFromDevice(rowData.id)}><CheckBoxIcon/></IconButton></Tooltip>
                :
				<Tooltip title={ETVConstants.trans('add')}><IconButton color='primary' onClick={()=>this.addContentToDevice(rowData.id)}><CheckBoxOutlineBlankIcon/></IconButton></Tooltip>},
					{ title: ETVConstants.trans('status'), field: 'status', width:70, render: rowData => ETVConstants.getLastConnectSymbol(rowData.last_connected,rowData.startup_datetime,rowData.status) },
					{ title: ETVConstants.trans('name'), field: 'device_name', width:280 },
          { title: ETVConstants.trans('location'), field: 'location_name' },

        ];

      return(
				<Box>
				  {(!this.state.isLoaded || this.state.isBulkUpdating) && <LinearProgress sx={{mb:1}}/>}
				  <Box sx={{display:'flex',gap:1,mb:2}}>
					<Button variant="outlined" startIcon={<DoneAllIcon/>} disabled={this.state.isBulkUpdating || this.state.items.length===0 || this.state.selected.length===this.state.items.length} onClick={()=>this.bulkSetScreens(true)}>
					  {ETVConstants.trans('select_all')}
					</Button>
					<Button variant="outlined" startIcon={<RemoveDoneIcon/>} disabled={this.state.isBulkUpdating || this.state.selected.length===0} onClick={()=>this.bulkSetScreens(false)}>
					  {ETVConstants.trans('deselect_all')}
					</Button>
				  </Box>
	          <ETVTable data={this.state.items} columns={columnsData} title="" pageSize={10} search={false} embedded options={{padding:'dense',tableLayout:'fixed'}} />
		   	</Box>
			);
	}
}

export default ScreenSelection
